module.exports = __webpack_public_path__ + "static/img/detail_location.cfa5e8ea.svg";